/* 
// JTM - RS  
// product builder - internal summary generate
*/
//function internalSummaryGenerate(myObj, self) {
function internalSummaryGenerate(myObj, isCurtainBuilder, isPanelBuilder, isPillowBuilder, isCoverBuilder, isCushionBuilder,shareLinkGenerated) {

  /* return empty string if window.PriceFormula.variables is undefined */
  if(typeof window.PriceFormula?.variables === 'undefined') {
    console.log("window.PriceFormula.variables is undefined");
    return '';
  }

    //console.log(self);
    //console.log("fetchInternalSummary .product-info-main.cd-form-valid");
    //console.log('window.PriceFormula.variables',window.PriceFormula.variables);

    //let productType = document.querySelector('input[data-cd-option-name^="product-type-"][type="radio"]:checked').closest(".field.choice").querySelector('label.label span').textContent.trim(); 
    //myObj["Product Type"] = productType;

    //myObj["Fabric Thumbnail URL"] = document.querySelector('#cd-step-fabric input[data-cd-option-name="cd--fabric-width"]').value;

    function encodeStr(str) {
      if (!str) return ""; // Returns an empty string if str is empty, null, or undefined
      return encodeURIComponent(str);
    }
   

    var builderType = $q('#itoris_dynamicproductoptions').data('builderType');
    /* 
    "curtain-builder"
    "panel-builder"
    "pillow-builder"
    "cover-builder"
    "loveseat-builder"
    "sofa-builder"
    "chair-builder"
    "chaise-builder"
    "barstool-builder"
    "daybed-builder"
    "ottoman-builder"
    "glider-swing-builder"
    "bench-window-builder"
    "floor-seating-builder"
    "breakfast-nook-builder" 
    */

    var shape = "";
    if (isCushionBuilder) {
      shape = $q('#itoris_dynamicproductoptions td._cd--shape input:checked').data('optionLabel');
    } else if(isCurtainBuilder){
      shape = $q('#itoris_dynamicproductoptions td._cd--shape input:checked').data('optionLabel');
    } else if(isPillowBuilder){
      // uses default ""
    } else if(isPanelBuilder){
      shape = $q('#itoris_dynamicproductoptions td._cd--shape input:checked').data('optionLabel');
    } else if(isCoverBuilder){
      // uses default ""
    }
    //console.log("shape",shape);

    if(!isFoamInsertOnlyBuilder){ // do not add fabric for foam only

      ///////////////////////////////////////
      // fabric 
      myObj["Fabric Name SKU"] = $q('#cd-step-fabric input[data-cd-option-name="cd--fabric-name-sku"]').val();
      myObj["Fabric Design"] = $q('#cd-step-fabric input[data-cd-option-name="cd--fabric-design"]').val();
      myObj["Fabric Width"] = $q('#cd-step-fabric input[data-cd-option-name="cd--fabric-width"]').val();
      myObj["Fabric Total Yards"] = $q('#cd-step-fabric input[data-cd-option-name="cd--total-fabric-yards"]').val();
      myObj["Fabric Image URL"] = encodeStr($q('#cd-step-fabric input[data-cd-option-name="cd--fabric-image-url"]').val());

      let fabricCost = Number($q('#cd-step-fabric input[data-cd-option-name="cd--fabric-price"').val()) || 0;
      let formattedCost = fabricCost.toFixed(2);
      myObj["Fabric Cost"] = "$" + formattedCost;  

      ///////////////////////////////////////
      // welt fabric
      if(document.querySelector('#cd-step-fabric input[data-cd-option-name="cd--welt-single"]:checked') !== null || document.querySelector('#cd-step-fabric input[data-cd-option-name="cd--welt-double"]:checked') !== null){
          myObj["Welt Fabric Name SKU"] = $q('#cd-step-fabric input[data-cd-option-name="cd--welt-name-sku"]').val();
          myObj["Welt Fabric Design"] = $q('#cd-step-fabric input[data-cd-option-name="cd--welt-fabric-design"]').val();
          myObj["Welt Fabric Width"] = $q('#cd-step-fabric input[data-cd-option-name="cd--welt-width"]').val();
          myObj["Welt Image URL"] = encodeStr($q('#cd-step-fabric input[data-cd-option-name="cd--welt-image-url"]').val());

          if (isCushionBuilder) {
              myObj["Welt Fabric Total Yards"] = $q('#cd-step-fabric input[data-cd-option-name="cd--total-welt-fabric-yards"').val();
          }
          
          let weltFabricCost = Number($('#cd-step-fabric input[data-cd-option-name="cd--welt-price"]').val()) || 0;
          let weltFormattedCost = weltFabricCost.toFixed(2);
          myObj["Welt Fabric Cost"] = "$" + weltFormattedCost;        
      }

    }

    //console.log("fabric-width input value",
    //$q('#cd-step-fabric input[data-cd-option-name="cd--fabric-width"]').val());
    //console.log("fabric width itoris var",window.PriceFormula.variables.fabricWidth);

    let totalItemPriceFee = window.PriceFormula.variables.totalItemPriceFee;
    //let totalItemPriceFee = (isFoamInsertOnlyBuilder) ? '0' : window.PriceFormula.variables?.totalItemPriceFee;
    //if(window.PriceFormula.variables.totalItemPriceFee = "-"){
    //totalItemPriceFee = "0";
    //}

    //////////////////////////////////////////////////////
    // declare seperate specific variabels for each builder type

    if (isCushionBuilder) { // is cushion builder

        //let inputProductType = $q('._cd--product-type input[type="radio"]:checked').next('label.label').find('span').text().trim();
        let stylePart = window.PriceFormula.variables.selectionStyle;

        // style
        myObj["Style"] = window.PriceFormula.variables.selectionStyle;
        myObj["Shape"] = window.PriceFormula.variables.selectionShape;
        myObj["Joining"] = (window.PriceFormula.variables.selectionJoining == 0 || window.PriceFormula.variables.selectionJoining == "" || typeof window.PriceFormula.variables.selectionJoining == "undefined") ? "N/A" : window.PriceFormula.variables.selectionJoining;


        if (builderType == "chair-builder" || builderType == "daybed-builder" || builderType == "glider-swing-builder") {

            if(shape == "Square / Rectangle") {

                if(stylePart == "Seat" || stylePart == "Seat and Back"){
                    
                    myObj["Dimension Seat Width"] = window.PriceFormula.variables.selectionDimensionSeatWidth;
                    myObj["Dimension Seat Depth"] = window.PriceFormula.variables.selectionDimensionSeatDepth;
                    myObj["Dimension Seat Thickness"] = window.PriceFormula.variables.selectionDimensionSeatThickness;
                }

                if(stylePart == "Back" || stylePart == "Seat and Back"){

                    myObj["Dimension Back Width"] = window.PriceFormula.variables.selectionDimensionBackWidth;
                    myObj["Dimension Back Height"] = window.PriceFormula.variables.selectionDimensionBackHeight;
                    myObj["Dimension Back Thickness"] = window.PriceFormula.variables.selectionDimensionBackThickness;
                }

            } else if(shape == "Isosceles Trapezoid") {

                if(stylePart == "Seat" || stylePart == "Seat and Back"){
                                        
                    myObj["Dimension Seat Rear Width"] = window.PriceFormula.variables.selectionDimensionSeatRearWidth;
                    myObj["Dimension Seat Front Width"] = window.PriceFormula.variables.selectionDimensionSeatFrontWidth;
                    myObj["Dimension Seat Depth"] = window.PriceFormula.variables.selectionDimensionSeatDepth;
                    myObj["Dimension Seat Thickness"] = window.PriceFormula.variables.selectionDimensionSeatThickness;
                }
                
                if(stylePart == "Back" || stylePart == "Seat and Back"){             
                    
                    myObj["Dimension Back Upper Width"] = window.PriceFormula.variables.selectionDimensionBackUpperWidth;
                    myObj["Dimension Back Lower Width"] = window.PriceFormula.variables.selectionDimensionBackLowerWidth;                    
                    myObj["Dimension Back Height"] = window.PriceFormula.variables.selectionDimensionBackHeight;
                    myObj["Dimension Back Thickness"] = window.PriceFormula.variables.selectionDimensionBackThickness;
                }

            } else if(shape == "Round") {

                if(stylePart == "Seat"){
                    
                    myObj["Dimension Seat Diameter"] = window.PriceFormula.variables.selectionDimensionSeatDiameter;
                    myObj["Dimension Seat Thickness"] = window.PriceFormula.variables.selectionDimensionSeatThickness;
                }
            }


        } else if(builderType == "loveseat-builder" || builderType == "sofa-builder"){

            // 1 Seat
            // 2 Seats
            // 3 Seats
            // 1 Back / 1 Seat
            // 2 Backs / 1 Seat
            // 2 Backs / 2 Seats
            // 3 Backs / 1 Seat
            // 3 Backs / 3 Seats

            if(shape == "Square / Rectangle") {

                if(stylePart == "1 Seat" || stylePart == "2 Seats" || stylePart == "3 Seats"){

                
                } else if(stylePart == "1 Back / 1 Seat" || stylePart == "2 Backs / 1 Seat" || stylePart == "2 Backs / 2 Seats" || stylePart == "3 Backs / 1 Seat" || stylePart == "3 Backs / 3 Seats"){

                }
            
            } else if(shape == "Isosceles Trapezoid") {

                if(stylePart == "1 Seat" || stylePart == "2 Seats" || stylePart == "3 Seats"){

                
                } else if(stylePart == "1 Back / 1 Seat" || stylePart == "2 Backs / 1 Seat" || stylePart == "2 Backs / 2 Seats" || stylePart == "3 Backs / 1 Seat" || stylePart == "3 Backs / 3 Seats"){

                }
            }


        } else if (builderType == "barstool-builder" || builderType == "ottoman-builder" || builderType == "bench-window-builder") {

            if(shape == "Square / Rectangle") {

                myObj["Dimension Seat Width"] = window.PriceFormula.variables.selectionDimensionSeatWidth;
                myObj["Dimension Seat Depth"] = window.PriceFormula.variables.selectionDimensionSeatDepth;
                myObj["Dimension Seat Thickness"] = window.PriceFormula.variables.selectionDimensionSeatThickness;
            
            } else if(shape == "Isosceles Trapezoid") {

                myObj["Dimension Seat Rear Width"] = window.PriceFormula.variables.selectionDimensionSeatRearWidth;
                myObj["Dimension Seat Front Width"] = window.PriceFormula.variables.selectionDimensionSeatFrontWidth;
                myObj["Dimension Seat Depth"] = window.PriceFormula.variables.selectionDimensionSeatDepth;
                myObj["Dimension Seat Thickness"] = window.PriceFormula.variables.selectionDimensionSeatThickness;
            }

        } else if (builderType == "chaise-builder") {

            // 1 Breaks, 2 Sections
            // 2 Breaks, 3 Sections
            // 3 Breaks, 4 Sections

            myObj["Dimension Section 1 Height"] = window.PriceFormula.variables.selectionDimensionBackHeight;
            myObj["Dimension Section 2 Depth"] = window.PriceFormula.variables.selectionDimensionSeat1Depth;
            myObj["Dimension Section 3 Depth"] = window.PriceFormula.variables.selectionDimensionSeat2Depth;
            myObj["Dimension Section 4 Depth"] = window.PriceFormula.variables.selectionDimensionSeat3Depth;

            /* if(stylePart == "1 Breaks, 2 Sections"){

                myObj["Dimension Seat 2 Depth"] = window.PriceFormula.variables.selectionDimensionSeat2Depth;

                //myObj["Dimension Seat 2 Width"] = window.PriceFormula.variables.productDimensionSeat2Width;
                //myObj["Dimension Seat 2 Depth"] = window.PriceFormula.variables.productDimensionSeat2Depth;
                //myObj["Dimension Seat 2 Thickness"] = window.PriceFormula.variables.productDimensionSeat2Thickness;

            } else if(stylePart == "2 Breaks, 3 Sections"){

                myObj["Dimension Seat 3 Depth"] = window.PriceFormula.variables.selectionDimensionSeat3Depth;

                //myObj["Dimension Seat 3 Width"] = window.PriceFormula.variables.productDimensionSeat3Width;
                //myObj["Dimension Seat 3 Depth"] = window.PriceFormula.variables.productDimensionSeat3Depth;
                //myObj["Dimension Seat 3 Thickness"] = window.PriceFormula.variables.productDimensionSeat3Thickness;

            } else if(stylePart == "3 Breaks, 4 Sections"){
                
                myObj["Dimension Seat 4 Depth"] = window.PriceFormula.variables.selectionDimensionSeat4Depth;
            } */
            
            myObj["Dimension Section Width"] = window.PriceFormula.variables.selectionDimensionBackWidth;
            myObj["Dimension Section Thickness"] = window.PriceFormula.variables.selectionDimensionBackThickness;

            //myObj["Dimension Back Width"] = window.PriceFormula.variables.productDimensionBackWidth;
            //myObj["Dimension Back Height"] = window.PriceFormula.variables.productDimensionBackHeight;
            //myObj["Dimension Back Thickness"] = window.PriceFormula.variables.productDimensionBackThickness;

        } else if (builderType == "breakfast-nook-builder") {

            

        } else if (builderType == "floor-seating-builder") {            
           
            if(stylePart == "Floor Cushion"){

                // needs formula to know what pricing formula to use?

            } else if(stylePart == "Floor Pillow") {                

                 // needs formula to know what pricing formula to use?

            }
        }



        /* 
        if (builderType == "chair-builder") {
            

        } else if (builderType == "chaise-builder") {


        } else if(builderType == "loveseat-builder"){


        } else if (builderType == "sofa-builder") {


        } else if (builderType == "barstool-builder") {
            

        } else if (builderType == "daybed-builder") {
            

        } else if (builderType == "ottoman-builder") {
            

        } else if (builderType == "glider-swing-builder") {
            

        } else if (builderType == "bench-window-builder") {
            

        } else if (builderType == "floor-seating-builder") {            
           
            if(document.querySelector('data-builder-product-type="product-type-floor-cushion"') !== null){

                // needs formula to know what pricing formula to use?

            } else if(document.querySelector('data-builder-product-type="product-type-floor-pillow"') !== null) {

                 // needs formula to know what pricing formula to use?
            }            

        } else if (builderType == "breakfast-nook-builder") {
            
           
        }
        */

        ///////////////////////////////////////
        // Corners
        myObj["Corners Seat"] = (window.PriceFormula.variables.selectionCornersSeat === 0 || window.PriceFormula.variables.selectionCornersSeat === "" || typeof window.PriceFormula.variables.selectionCornersSeat == "undefined") ? "N/A" : window.PriceFormula.variables.selectionCornersSeat;
        myObj["Corners Seat Rounding"] = (window.PriceFormula.variables.selectionCornersSeatRounding === 0 || window.PriceFormula.variables.selectionCornersSeatRounding === "" || typeof window.PriceFormula.variables.selectionCornersSeatRounding == "undefined") ? "N/A" : window.PriceFormula.variables.selectionCornersSeatRounding;
        myObj["Corners Back"] = (window.PriceFormula.variables.selectionCornersBack === 0 || window.PriceFormula.variables.selectionCornersBack === "" || typeof window.PriceFormula.variables.selectionCornersBack == "undefined") ? "N/A" : window.PriceFormula.variables.selectionCornersBack;
        myObj["Corners Back Rounding"] = (window.PriceFormula.variables.selectionCornersBackRounding === 0 || window.PriceFormula.variables.selectionCornersBackRounding === "" || typeof window.PriceFormula.variables.selectionCornersBackRounding == "undefined") ? "N/A" : window.PriceFormula.variables.selectionCornersBackRounding;

        ///////////////////////////////////////
        // Fill 
        myObj["Fill Seat"] = (window.PriceFormula.variables.selectionFillSeat === 0 || window.PriceFormula.variables.selectionFillSeat === "" || typeof window.PriceFormula.variables.selectionFillSeat == "undefined") ? "N/A" : window.PriceFormula.variables.selectionFillSeat;
        var matchSeatFoamEl;
        if((matchSeatFoamEl = document.querySelector('.cd-steps__panel [data-cd-option-name="cd--fill-back-match-seat"].cd-input:checked')) !== null){
            myObj["Fill Back Match Seat"] = (window.PriceFormula.variables.backMatchSeatFill === 0 || window.PriceFormula.variables.backMatchSeatFill === "" || typeof window.PriceFormula.variables.backMatchSeatFill == "undefined") ? "N/A" : window.PriceFormula.variables.backMatchSeatFill;
        }
        var matchSeatFoamEl2;
        if((matchSeatFoamEl2 = document.querySelector('.cd-steps__panel [data-cd-option-name="cd--fill-back-match-seat"].cd-input:not(:checked)')) !== null){
            myObj["Fill Back"] = (window.PriceFormula.variables.selectionFillBack === 0 || window.PriceFormula.variables.selectionFillBack === ""|| typeof window.PriceFormula.variables.selectionFillBack == "undefined") ? "N/A" : window.PriceFormula.variables.selectionFillBack;
        }
        ///////////////////////////////////////
        // Ties
        if(!isFoamInsertOnlyBuilder){ // do not add ties for foam only

          myObj["Ties Seat"] = (window.PriceFormula.variables.selectionTiesSeat === 0 || window.PriceFormula.variables.selectionTiesSeat === "" || typeof window.PriceFormula.variables.selectionTiesSeat == "undefined") ? "N/A" : window.PriceFormula.variables.selectionTiesSeat; 
          myObj["Ties Seat Position"] = (document.querySelectorAll('._cd--ties-position-seat input[type="checkbox"]:checked').length === 0  || window.PriceFormula.variables.selectionTiesSeatPosition == "" || typeof window.PriceFormula.variables.selectionTiesSeatPosition == "undefined") ? "N/A" : window.PriceFormula.variables.selectionTiesSeatPosition;
          myObj["Ties Back"] = (window.PriceFormula.variables.selectionTiesBack === 0 || window.PriceFormula.variables.selectionTiesBack === "" || typeof window.PriceFormula.variables.selectionTiesBack == "undefined") ? "N/A" : window.PriceFormula.variables.selectionTiesBack;
          myObj["Ties Back Position"] = (document.querySelectorAll('._cd--ties-position-back input[type="checkbox"]:checked').length === 0 || window.PriceFormula.variables.selectionTiesBackPosition == "" || typeof window.PriceFormula.variables.selectionTiesBackPosition == "undefined") ? "N/A" : window.PriceFormula.variables.selectionTiesBackPosition;

          myObj["Total Cost Ties"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalCostTies).toFixed(2);
          myObj["Extra Total Unit Price"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalUnitPriceExtras).toFixed(2);
          myObj["Extras Total Item Price"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);
        }

        // Cushion Labor minutes breakdown and charge.
        
        myObj["Labor - Time Design Cut Minutes"] = window.PriceFormula.variables.timeLaborDesignCutMinutes.toFixed(2);
        myObj["Labor - Time Sewing Minutes"] = window.PriceFormula.variables.timeLaborSewingMinutes.toFixed(2);
        myObj["Labor - Time Welt Minutes"] = window.PriceFormula.variables.timeLaborWeltMinutes.toFixed(2);
        myObj["Labor - Time Quality Control Minutes"] = window.PriceFormula.variables.timeLaborQualityControlMinutes.toFixed(2);
        myObj["Labor - Time Shipping Minutes"] = window.PriceFormula.variables.timeLaborShippingMinutes.toFixed(2);
        myObj["Labor - Time Total Minutes"] = window.PriceFormula.variables.timeLaborMinutes.toFixed(2);
        /* if (window.PriceFormula?.variables?.timeLaborDesignCutMinutes != null) {
          myObj["Labor - Time Design Cut Minutes"] = window.PriceFormula.variables.timeLaborDesignCutMinutes.toFixed(2);
        }

        if (window.PriceFormula?.variables?.timeLaborSewingMinutes != null) {
          myObj["Labor - Time Sewing Minutes"] = window.PriceFormula.variables.timeLaborSewingMinutes.toFixed(2);
        }

        if (window.PriceFormula?.variables?.timeLaborWeltMinutes != null) {
          myObj["Labor - Time Welt Minutes"] = window.PriceFormula.variables.timeLaborWeltMinutes.toFixed(2);
        }

        if (window.PriceFormula?.variables?.timeLaborQualityControlMinutes != null) {
          myObj["Labor - Time Quality Control Minutes"] = window.PriceFormula.variables.timeLaborQualityControlMinutes.toFixed(2);
        }

        if (window.PriceFormula?.variables?.timeLaborShippingMinutes != null) {
          myObj["Labor - Time Shipping Minutes"] = window.PriceFormula.variables.timeLaborShippingMinutes.toFixed(2);
        }

        if (window.PriceFormula?.variables?.timeLaborMinutes != null) {
          myObj["Labor - Time Total Minutes"] = window.PriceFormula.variables.timeLaborMinutes.toFixed(2);
        } */

        // Cushion Shipping charges breakdown
        
        myObj["Shipping - Base Shipping Charges"] = "$" + Number.parseFloat(window.PriceFormula.variables.productShippingBaseAmount).toFixed(2);
        myObj["Shipping - Long Dimension Charges"] = "$" + Number.parseFloat(window.PriceFormula.variables.productShippingLongDimensionCharge).toFixed(2);
        myObj["Shipping - Girth Charges"] = "$" + Number.parseFloat(window.PriceFormula.variables.productShippingLargeGirthCharge).toFixed(2);
        myObj["Shipping - Handling Charges"] = "$" + Number.parseFloat(window.PriceFormula.variables.productShippingHandling).toFixed(2);
        myObj["Shipping - Shipping Insurance Charges"] = "$" + Number.parseFloat(window.PriceFormula.variables.productShippingInsurance).toFixed(2);
        
        myObj["Total Item Price Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFabric).toFixed(2);
        myObj["Total Item Price Welt Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceWeltFabric).toFixed(2);
        myObj["Total Item Price Fill"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFill).toFixed(2);
        myObj["Total Item Price Labor"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceLabor).toFixed(2);
        myObj["Total Item Price Extras"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);
        myObj["Total Item Price Shipping"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceShipping).toFixed(2);
        myObj["Total Item Price Margin"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceDesiredMargin).toFixed(2);
        myObj["Total Item Price Fees"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFee).toFixed(2);


    } else if (isCurtainBuilder) { // is curtain builder

        //console.log(window.PriceFormula.variables);

        myObj["Dimensions Width"] = window.PriceFormula.variables.productWidth;
        myObj["Dimensions Length"] = window.PriceFormula.variables.productLength;
        myObj["Lead Free Bottom Weights"] = window.PriceFormula.variables.extrasBottomWeightsTitle;
        if (document.querySelector('td._cd--grommets input:checked') !== null) {
            myObj["Grommets Selection"] = document.querySelector('td._cd--grommets input:checked + label span').textContent.trim(); //window.PriceFormula.variables.grommetColor;
        }
        //myObj["Curtain Hardware Selection"] = window.PriceFormula.variables.extrasHardwareLengthSelection;
        //myObj["Curtain Hardware Cost"] = "$" + Number.parseFloat(window.PriceFormula.variables.extrasHardwareLengthSelectionCost).toFixed(2);
        // myObj["Bottom Corner Grommet Selection"] = window.PriceFormula.variables.extrasBottomCornerGrommetSelection;
        //myObj["Bottom Corner Grommet Cost"] = "$" + Number.parseFloat(window.PriceFormula.variables.extrasBottomCornerGrommetCost).toFixed(2);

        myObj["Grommets Required"] = window.PriceFormula.variables.grommetsRequired;
        myObj["Total Item Price Grommets"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceGrommets).toFixed(2);
        myObj["Total Item Price Extras"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);
        myObj["Total Item Price Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFabric).toFixed(2);
        myObj["Total Item Price Labor"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceLabor).toFixed(2);
        myObj["Total Item Price Shipping"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceShipping).toFixed(2);
        myObj["Total Item Price Markup"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceMarkup).toFixed(2);

        myObj["Total Item Price Fees"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFee).toFixed(2);

    } else if (isPanelBuilder) { // is panel builder

        myObj["Dimensions Width"] = window.PriceFormula.variables.productWidth;
        myObj["Dimensions Length"] = window.PriceFormula.variables.productLength;

        if (window.PriceFormula.variables.productType === "Grommet") {

            if (document.querySelector('td._cd--grommets input:checked') !== null) {
                myObj["Grommets Selection"] = document.querySelector('td._cd--grommets input:checked + label span').textContent.trim(); //window.PriceFormula.variables.grommetColor;
            }

            if(document.querySelector('._cd--grommet-location input[type="checkbox"][data-cd-option-name="cd--grommet-location-all-four-sides"]:checked') !== null){
                myObj["Grommet Locations All Four Sides"] = (window.PriceFormula.variables.grommetLocationAllFourSides == ""  || window.PriceFormula.variables.grommetLocationAllFourSides == 0 || typeof window.PriceFormula.variables.grommetLocationAllFourSides == "undefined") ? "N/A" :  window.PriceFormula.variables.grommetLocationAllFourSides;
            }

            if(document.querySelector('._cd--grommet-location input[type="checkbox"][data-cd-option-name="cd--grommet-location-bottom-side"]:checked') !== null){
                myObj["Grommet Locations Bottom Side"] = (window.PriceFormula.variables.grommetLocationBottomSide == "" || window.PriceFormula.variables.grommetLocationBottomSide == 0 || typeof window.PriceFormula.variables.grommetLocationBottomSide == "undefined") ? "N/A" : window.PriceFormula.variables.grommetLocationBottomSide;
            }

            if(document.querySelector('._cd--grommet-location input[type="checkbox"][data-cd-option-name="cd--grommet-location-left-side"]:checked') !== null){
                myObj["Grommet Locations Left Side"] = (window.PriceFormula.variables.grommetLocationLeftSide == "" || window.PriceFormula.variables.grommetLocationLeftSide == 0 || typeof window.PriceFormula.variables.grommetLocationLeftSide == "undefined") ? "N/A" : window.PriceFormula.variables.grommetLocationLeftSide;
            }

            if(document.querySelector('._cd--grommet-location input[type="checkbox"][data-cd-option-name="cd--grommet-location-right-side"]:checked') !== null){
                myObj["Grommet Locations Right Side"] = (window.PriceFormula.variables.grommetLocationRightSide == "" || window.PriceFormula.variables.grommetLocationRightSide == 0 || typeof window.PriceFormula.variables.grommetLocationRightSide == "undefined") ? "N/A" : window.PriceFormula.variables.grommetLocationRightSide;
            }

            if(document.querySelector('._cd--grommet-location input[type="checkbox"][data-cd-option-name="cd--grommet-location-top-side"]:checked') !== null){
                myObj["Grommet Locations Top Side"] = (window.PriceFormula.variables.grommetLocationTopSide == "" || window.PriceFormula.variables.grommetLocationTopSide == 0 || typeof window.PriceFormula.variables.grommetLocationTopSide == "undefined") ? "N/A" : window.PriceFormula.variables.grommetLocationTopSide;
            }

            myObj["Grommets Required"] = window.PriceFormula.variables.grommetsRequired;
            myObj["Total Item Price Grommets"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceGrommets).toFixed(2);

        } else if (window.PriceFormula.variables.productType === "Side Pocket") {

            if(document.querySelector('._cd-side-pocket-location input[type="checkbox"][data-cd-option-name="cd--side-pocket-location-all-four-sides"]:checked') !== null){
                myObj["Side Pocket Locations All Four Sides"] = (window.PriceFormula.variables.sidePocketLocationAllFourSides == "" || window.PriceFormula.variables.sidePocketLocationAllFourSides == 0 || typeof window.PriceFormula.variables.sidePocketLocationAllFourSides == "undefined") ? "N/A" :  window.PriceFormula.variables.sidePocketLocationAllFourSides;
            }

            if(document.querySelector('._cd-side-pocket-location input[type="checkbox"][data-cd-option-name="cd--side-pocket-location-bottom-side"]:checked') !== null){
                myObj["Side Pocket Locations Bottom Side"] = (window.PriceFormula.variables.sidePocketLocationBottomSide == "" || window.PriceFormula.variables.sidePocketLocationBottomSide == 0 || typeof window.PriceFormula.variables.sidePocketLocationBottomSide == "undefined") ? "N/A" : window.PriceFormula.variables.sidePocketLocationBottomSide;
            }

            if(document.querySelector('._cd-side-pocket-location input[type="checkbox"][data-cd-option-name="cd--side-pocket-location-left-side"]:checked') !== null){
                myObj["Side Pocket Locations Left Side"] = (window.PriceFormula.variables.sidePocketLocationLeftSide == "" || window.PriceFormula.variables.sidePocketLocationLeftSide == 0 || typeof window.PriceFormula.variables.sidePocketLocationLeftSide == "undefined") ? "N/A" : window.PriceFormula.variables.sidePocketLocationLeftSide;
            }

            if(document.querySelector('._cd-side-pocket-location input[type="checkbox"][data-cd-option-name="cd--side-pocket-location-right-side"]:checked') !== null){
                myObj["Side Pocket Locations Right Side"] = (window.PriceFormula.variables.sidePocketLocationRightSide == "" || window.PriceFormula.variables.sidePocketLocationRightSide == 0 || typeof window.PriceFormula.variables.sidePocketLocationRightSide == "undefined") ? "N/A" : window.PriceFormula.variables.sidePocketLocationRightSide;
            }

            if(document.querySelector('._cd-side-pocket-location input[type="checkbox"][data-cd-option-name="cd--side-pocket-location-top-side"]:checked') !== null){
                myObj["Side Pocket Locations Top Side"] = (window.PriceFormula.variables.sidePocketLocationTopSide == ""  || window.PriceFormula.variables.sidePocketLocationTopSide == 0 || typeof window.PriceFormula.variables.sidePocketLocationTopSide == "undefined") ? "N/A" : window.PriceFormula.variables.sidePocketLocationTopSide;
            }

            myObj["Total Item Price Side Pockets"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalUnitPriceSidePocket).toFixed(2);

            /* 
            sidePocketLocationLeftSide: 
            sidePocketLocationRightSide: 
            sidePocketLocationTopSide: 
            */

        } else if (window.PriceFormula.variables.productType === "Snap Fastener") {

            myObj["Snap Fasteners"] = window.PriceFormula.variables.snapFastenerColor;
            if (document.querySelector('td._cd--snap-fasteners-type input:checked') !== null) {
                myObj["Snap Fasteners Type"] = document.querySelector('td._cd--snap-fasteners-type input:checked + label span').textContent.trim(); //window.PriceFormula.variables.grommetColor;
            }
            myObj["Snap Fasteners Required"] = window.PriceFormula.variables.snapFastenerRequired;
            myObj["Snap Fasteners Color"] = window.PriceFormula.variables.snapFastenerColor;
            myObj["Snap Fasteners Location"] = window.PriceFormula.variables.snapFastenerLocation;
            myObj["Total Item Price Snap Fasteners"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceSnapFastener).toFixed(2);
        }

        //myObj["Total Item Price Extras"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);

        myObj["Total Item Price Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFabric).toFixed(2);
        myObj["Total Item Price Labor"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceLabor).toFixed(2);
        myObj["Total Item Price Shipping"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceShipping).toFixed(2);
        myObj["Total Item Price Markup"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceMarkup).toFixed(2);

        myObj["Total Item Price Fees"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFee).toFixed(2);

    } else if (isPillowBuilder) { // is pilllow builder

        if (window.PriceFormula.variables.selectionPillowType === "Bolster") {
            myObj["Dimensions Diameter"] = Number.parseFloat(window.PriceFormula.variables.productDiameter);
            myObj["Dimensions Length"] = Number.parseFloat(window.PriceFormula.variables.productLength).toFixed(2);
        } else {
            myObj["Dimensions Width"] = Number.parseFloat(window.PriceFormula.variables.productWidth).toFixed(2);
            myObj["Dimensions Hieght"] = Number.parseFloat(window.PriceFormula.variables.productHeight).toFixed(2);
        }
        
        if (window.PriceFormula.variables.selectionPillowType === "Standard Size") {
            myObj["Size Preset"] = window.PriceFormula.variables.selectionSizePreset;
            myObj["Size Preset Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.sizePresetCost).toFixed(2);
        }

        myObj["Dimensions Thickness"] = Number.parseFloat(window.PriceFormula.variables.productThickness);

        myObj["Fill"] = window.PriceFormula.variables.selectionFill;
        myObj["Fill Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.fillCost).toFixed(2);

        myObj["Cubic Inches"] = Number.parseFloat(window.PriceFormula.variables.cubicInches).toFixed(2);
        myObj["Labor Cost Per Cubic Inch"] = "$" + Number.parseFloat(window.PriceFormula.variables.laborCostPerCubicInch).toFixed(4);
        myObj["Labor Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.laborCost).toFixed(2);

        myObj["Welt"] = window.PriceFormula.variables.selectionWelt;
        myObj["Welt Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.weltCost).toFixed(2);

        myObj["Shipping Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.shippingCost).toFixed(2);
        myObj["Markup Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.markupCost).toFixed(2);
        myObj["Fee Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.feeCost).toFixed(2);

        // need to add foam and welt and other pillow internal summary options
        myObj["Total Item Price Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFabric).toFixed(2);

        if (window.PriceFormula.variables.selectionPillowType === "Standard Size") {
            myObj["Total Item Price Size Preset"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceSizePreset).toFixed(2);
        }

        myObj["Total Item Price Fill"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFill).toFixed(2);
        myObj["Total Item Price Labor"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceLabor).toFixed(2);
        myObj["Total Item Price Extras"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);
        myObj["Total Item Price Shipping"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceShipping).toFixed(2);
        myObj["Total Item Price Markup"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceMarkup).toFixed(2);
        myObj["Total Item Price Fees"] = "$" + Number.parseFloat(totalItemPriceFee).toFixed(2);


    } else if (isCoverBuilder) { // is cover builder

        //if (window.PriceFormula.variables.selectionPillowType === "Furniture Cover") {}

        myObj["Dimensions Width"] = Number.parseFloat(window.PriceFormula.variables.productWidth).toFixed(2);
        myObj["Dimensions Length"] = Number.parseFloat(window.PriceFormula.variables.productLength).toFixed(2);
        myObj["Dimensions Height"] = Number.parseFloat(window.PriceFormula.variables.productHeight).toFixed(2);

        myObj["Cubic Inches"] = Number.parseFloat(window.PriceFormula.variables.cubicInches).toFixed(2);

        myObj["Labor Cost Per Cubic Inch"] = "$" + Number.parseFloat(window.PriceFormula.variables.laborCostPerCubicInch).toFixed(4);
        myObj["Labor Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.laborCost).toFixed(2);

        myObj["Corner Zipper"] = window.PriceFormula.variables.selectionZipper;
        myObj["Corner Zipper Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.zipperCost).toFixed(2);

        myObj["Zipper Flap"] = window.PriceFormula.variables.selectionFlap;
        myObj["Zipper Flap Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.flapCost).toFixed(2);

        myObj["Corner Patch Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.patchCost).toFixed(2);

        myObj["Markup Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.markupCost).toFixed(2);
        myObj["Fee Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.feeCost).toFixed(2);
        myObj["Square Feet"] = Number.parseFloat(window.PriceFormula.variables.squareFeet).toFixed(2);
        myObj["Shipping Cost Per Unit"] = "$" + Number.parseFloat(window.PriceFormula.variables.shippingCost).toFixed(2);

        myObj["Total Item Price Per Square Foot"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalUnitPricePerSquareFoot).toFixed(2);
        myObj["Total Item Price Fabric"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFabric).toFixed(2);

        myObj["Total Item Price Labor"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceLabor).toFixed(2);
        //myObj["Total Item Price Extras"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceExtras).toFixed(2);
        myObj["Total Item Price Shipping"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceShipping).toFixed(2);
        myObj["Total Item Price Markup"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceMarkup).toFixed(2);

        myObj["Total Item Price Fees"] = "$" + Number.parseFloat(window.PriceFormula.variables.totalItemPriceFee).toFixed(2);

    }

    // B2B activeB2Bgroup
    if(activeB2Bgroup !== "None") {
        myObj["B2B Customer Group"] = activeB2Bgroup;
        myObj["B2B Percentage Off"] = builderB2bPercentageOff + '%';
    }

    let customerNotesValue = document.querySelector('textarea[data-cd-option-name="cd-extras--customer-notes"]').value;
    if(customerNotesValue !== "") {
        myObj["Customer Notes"] = customerNotesValue;
    }
    
    let internalSummaryNotesValue = document.querySelector('#cd-step-internal-summary textarea[data-cd-option-name="cd--internal-notes"]').value;
    if(internalSummaryNotesValue !== "") {
        myObj["Internal Summary Notes"] = internalSummaryNotesValue;
    }     
    

    /* temp hide until share link is enabled and working */
    //myObj["Product Builder Key URL"] = document.querySelector('.share-link-input').value;
    if(shareLinkGenerated == false) {
      myObj["Product Builder Key URL"] = "Share Link Not Generated";
    }

    // commented out since if someone changes quantity cart page, internal summary object won't get updated since it only updates on the product page not the cart page
    //if (document.querySelector('.product-info__add-to-cart .qty-input__input.input') !== null) {
        //myObj["Quantity"] = document.querySelector('.product-info__add-to-cart .qty-input__input.input').value; 
        //myObj["Quantity"] = window.PriceFormula.variables.selectionQuantity;
    //}

    return myObj;    
}